import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { useState } from "react";

import { usePageTitle } from "@/utils/usePageTitle";

import { useGetCompanySizesQuery } from "../../redux/company-size/company-size.api";
import { companySizeSelector } from "../../redux/company-size/company-size.slice";
import EditableCompanySizeList from "./components/EditableCompanySizeList";

export default function ManageCompanySize() {
	const { isLoading: isLoadingInitialData } = useGetCompanySizesQuery();
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-company-size.${key}`);
	const companySizes = useSelector(companySizeSelector);
	const [editingCompanySizeId, setCompanySizeId] = useState(-1);

	usePageTitle(ts("title"));

	return (
		<div className="p-6">
			<EditableCompanySizeList
				data={companySizes}
				editingCompanySizeId={editingCompanySizeId}
				isLoading={isLoadingInitialData}
				setEditingCompanySizeId={setCompanySizeId}
			/>
		</div>
	);
}
